<div class="wrapper" *qmLoading="loading;config:loadingConfig">
  <div #chart class="chart">
    <div class="chart-indicator-row" *ngIf="stations" [ngStyle]="{'grid-template-columns': '80px repeat(' + stations.length*2 + ',' + columnWidthPx/2 + 'px)'}">
      <div></div>
        <div #indicator class="indicator" *ngIf="trainLocation.columnIndex" [ngStyle]="{'grid-column': trainLocation.columnIndex+3}">
          <div class="diff-indicator">
            <p [ngClass]="{
              'red-background': train.status === 'danger',
              'green-background': train.status === 'success',
              'blue-background': train.status === 'info',
              'yellow-background': train.status === 'warning'
            }">
              {{train.calculatedDelta}}
            </p>
          </div>
          <div style="position: relative; bottom: 35px;">
            <span class="indicator-arrow-right"></span>
          </div>
        </div>
    </div>
    <div class="chart-row chart-period" *ngIf="stations" [ngStyle]="{'grid-template-columns': '80px repeat(' + stations.length + ',' + columnWidthPx + 'px)'}">
      <div></div>
        <span [ngClass]="{'grey-background': station.passed, 'green-background': !station.passed}" *ngFor="let station of stations">{{ station.shortCode }}</span>
    </div>
    <div class="chart-row chart-lines" *ngIf="stations" [ngStyle]="{'grid-template-columns': '80px repeat(' + stations.length + ',' + columnWidthPx + 'px)'}"> 
      <span [ngStyle]="{'width': columnWidthPx + 'px;'}" *ngFor="let stationCode of stations"></span>
    </div>
    <div class="chart-row" *ngFor="let row of timelineRows">  
      <div class="chart-row-item">{{ row.label }}</div> 
      <ul class="chart-row-bars" *ngIf="stations" [ngStyle]="{'grid-template-columns': 'repeat(' + stations.length*2 + ',' + columnWidthPx/2 + 'px)'}">
        <li 
          [ngClass]="{
            'chart-li': true,
            'grey-background': rowData.toColumn <= trainLocation.columnIndex+2 && !rowData.alarm,
            'dark-grey-background': rowData.toColumn > trainLocation.columnIndex+2 && !rowData.alarm,
            'red-background': rowData.alarm
          }"
          *ngFor="let rowData of row.datas" #ttip="qmTooltip" [qmTooltip]="tipContent" [clientRect]="tooltipRect | async" (tipClick)="toggleTooltip($event, ttip, rowData)"
          [ngStyle]="{'grid-column': rowData.fromColumn + '/' + rowData.toColumn}">
          {{ rowData.label }}
        </li>
      </ul>
    </div>
  </div>
  <ng-template #tipContent let-shiftInfo="shiftInfo" let-shiftTaskInfo="shiftTaskInfo">
    <div>
      <qm-vr-workshift-tooltip [shiftInfo]="shiftInfo" [shiftTaskInfo]="shiftTaskInfo" (loaded)="onLoaded($event)"></qm-vr-workshift-tooltip>
    </div>
  </ng-template>
</div>
